import { EventActionType } from './event-action-type';
import { castArray } from 'lodash';

export interface UpdateEventErrorAction {
  errors: Error[];
  eventKey: string;
  type: EventActionType.UpdateEventError;
}

export const updateEventError = (
  eventKey: string,
  errors: Error | readonly Error[],
): UpdateEventErrorAction => ({
  errors: castArray(errors),
  eventKey,
  type: EventActionType.UpdateEventError,
});
